import { api } from "../AxiosInstance";
export interface PdpDriver {
  driverId: number; driverName: string; transporterId: number;
  pdpNumber: string | null; pdpIssueDate: string | null; pdpExpiryDate: string | null;
  status: "MISSING" | "VALID" | "EXPIRING_SOON" | "EXPIRED";
  reminderAt: string | null; renewalDeadline: string | null;
  renewalOpenNow: boolean; nextRenewalWindow: string;
}
export interface PdpListing {content: PdpDriver[]; totalElements: number; limit: number; skip: number;}
export function errorMessage(error: any): string {
  const body=error?.response?.data;
  return typeof body === "string" ? body : body?.message || error?.message || "Request failed";
}
const PdpService = {
  list: async (status: string, skip=0, signal?: AbortSignal): Promise<PdpListing> => {
    const response=await api.get("/pdp/drivers",{params:{status:status || undefined,limit:30,skip},signal});
    if(response.data.error) throw new Error(response.data.message);
    return response.data.data;
  },
  alerts: async (signal?: AbortSignal) => {
    const response=await api.get("/pdp/alerts",{params:{limit:30},signal});
    if(response.data.error) throw new Error(response.data.message);
    return response.data.data;
  },
  get: async (id: number, signal?: AbortSignal): Promise<PdpDriver> => {
    const r=await api.get(`/pdp/drivers/${id}`,{signal});
    if(r.data.error)throw new Error(r.data.message);return r.data.data;
  },
  update: async (id: number, fields: {pdpNumber:string;pdpIssueDate:string;pdpExpiryDate?:string}) => {
    const r=await api.put(`/pdp/drivers/${id}`,fields);
    if(r.data.error)throw new Error(r.data.message);return r.data.data;
  },
  documentInfo: async (id: number, signal?: AbortSignal) => {
    const r=await api.get(`/pdp/drivers/${id}/document/info`,{signal});return r.data.data;
  },
  uploadDocument: async (id: number,file: File) => {
    const form=new FormData();form.append("file",file);
    const r=await api.post(`/pdp/drivers/${id}/document`,form,{headers:{"Content-Type":"multipart/form-data"}});
    if(r.data.error)throw new Error(r.data.message);return r.data.data;
  },
  downloadDocument: async (id: number) => {
    const r=await api.get(`/pdp/drivers/${id}/document`,{responseType:"blob"});
    const url=URL.createObjectURL(r.data);const a=document.createElement("a");a.href=url;a.download=`pdp-driver-${id}.pdf`;a.click();
    window.setTimeout(()=>URL.revokeObjectURL(url),1000);
  },
  assign: async (tripId: number, driverId: number, acknowledged: boolean, reason: string) => {
    const response=await api.post("/trip/assign-trip-to-driver",{jobBreakupDetailId:tripId,driverId,
      pdpOverrideAcknowledged:acknowledged,pdpOverrideReason:reason || undefined});
    if(response.data.error) throw new Error(response.data.message);
    return response.data.data;
  }
};
export default PdpService;
